import React, { useContext } from "react";
import { Col, Row } from "react-bootstrap";
import "./CourseIntroduction.css";
import TimerComponent from "../../Components/TimerComponent/TimerComponent";
import ProgressBar from "react-bootstrap/ProgressBar";
import ImageNotFound from "../../Assets/images/ImageNotFound.jpg";
import { SlBasketLoaded } from "react-icons/sl";
import { BsShareFill, BsTwitter } from "react-icons/bs";
import { FaTelegramPlane } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { BiLogoLinkedin } from "react-icons/bi";
import CourseInfoBox from "../CourseInfoBox/CourseInfoBox";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";
import { addToBasket } from "../../Helpers/basketHelper";
import ReactPlayer from "react-player";
import { CartContext } from "../../Hooks/CartContext";

export default function CourseIntroduction({ courseData }) {
    const { cartItems, addToCart } = useContext(CartContext);
    let daysDiff = 0;
    let currentDate = new Date();
    if (courseData.discount != null) {
        let startDate = new Date(courseData.discount?.startTime);

        let timeDiff = currentDate.getTime() - startDate.getTime();
        daysDiff = Math.floor(timeDiff / (1000 * 3600 * 24));
    }

    return (
        <div className="course-introduction">
            <div className="course-introduction-title">
                <h1>{courseData.title}</h1>
                <span>
                    {courseData.courseLevel === 0
                        ? "مبتدی"
                        : courseData.courseLevel === 1
                            ? "متوسط"
                            : courseData.courseLevel === 2
                                ? "پیشرفته"
                                : ""}
                </span>
            </div>
            <Row>
                <Col lg={4}>
                    <div className="course-introduction-right">
                        <CourseInfoBox courseData={courseData} />
                        {
                            courseData.discount != null != null && new Date(courseData.discount?.startTime).getTime() >= currentDate.getTime()
                                && new Date(courseData.discount?.startTime).getTime() <= currentDate.setDate(currentDate.getDate() + parseInt(courseData.discount?.duration)) ? (
                                <div className="course-introduction-timer">
                                    <span className="course-introduction-timer-text">
                                        زمان پایان تخفیف
                                    </span>
                                    <div className="course-introduction-timer-component">
                                        <TimerComponent time={(parseInt(courseData.discount?.duration) - daysDiff)} />
                                    </div>
                                </div>
                            ) : (<></>)

                        }
                        <button
                            onClick={async () => {
                                // i know , 0 is not readable , but it means course
                                const res = await addToBasket(courseData.id, 0, 1);
                                if (res) addToCart(cartItems + 1)
                            }}
                        >
                            <SlBasketLoaded />
                            افزودن به سبد خرید
                        </button>
                        <div className="progress-bar">
                            <ProgressBar now={courseData.percentComplete} />
                            <h3>
                                {courseData.percentComplete} درصد دوره تکمیل شده
                            </h3>
                        </div>
                        <div className="course-introduction-teacher">
                            <div className="course-introduction-teacher-profile">
                                {courseData.registererUser?.profileImage !=
                                    null ? (
                                    <img
                                        src={
                                            axiosConfig.defaults.baseURL +
                                            "Images/UserImage/" +
                                            courseData.registererId +
                                            "/" +
                                            courseData.registererUser
                                                ?.profileImage
                                        }
                                        alt={`تصویر ${courseData.instructorName} مدرس دوره`}

                                    />
                                ) : (
                                    <img src={ImageNotFound} alt={`تصویر ${courseData.instructorName} مدرس دوره`}/>
                                )}
                                <h3>{courseData.instructorName}</h3>
                            </div>
                        </div>
                        <div className="course-introduction-bottom-info">
                            <Row>
                                <Col>
                                    <div className="course-introduction-comment">
                                        <span>{courseData.commentCount}</span>
                                        <h3>دیدگاه</h3>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="course-introduction-course-time">
                                        <span>{courseData.totalCourseDuration}</span>
                                        <h3>آموزش</h3>
                                    </div>
                                </Col>
                                <Col>
                                    <div className="course-introduction-course-level">
                                        <span>
                                            {" "}
                                            {courseData.courseLevel === 0
                                                ? "مبتدی"
                                                : courseData.courseLevel === 1
                                                    ? "متوسط"
                                                    : courseData.courseLevel === 2
                                                        ? "پیشرفته"
                                                        : ""}
                                        </span>
                                        <h3>سطح دوره</h3>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </Col>
                <Col lg={8}>
                    <div className="course-introduction-left">
                        <div className="course-introduction-video">
                            <ReactPlayer
                                url={axiosConfig.defaults.baseURL +
                                    "Images/CourseVideo/" +
                                    courseData.id +
                                    "/" +
                                    courseData.videoPath}
                                config={{ file: { attributes: { controlsList: 'nodownload' } } }}
                                onContextMenu={e => e.preventDefault()}
                                controls
                            />
                        </div>
                        <div className="course-introduction-share">
                            <div className="course-introduction-share-icon">
                                <BsShareFill />
                                اشتراک گزاری
                            </div>
                            <div className="course-introduction-social">
                                <ul>
                                    <li>
                                        <AiFillInstagram />
                                    </li>
                                    <li>
                                        <FaTelegramPlane />
                                    </li>
                                    <li>
                                        <BsTwitter />
                                    </li>
                                    <li>
                                        <BiLogoLinkedin />
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    );
}
